var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5556 6V1.33333C15.5556 0.979707 15.4384 0.640573 15.2301 0.39052C15.0218 0.14048 14.7391 0 14.4444 0H1.11111C0.816422 0 0.533811 0.14048 0.325433 0.39052C0.117067 0.640573 0 0.979707 0 1.33333V14.6667C0 15.0203 0.117067 15.3595 0.325433 15.6095C0.533811 15.8595 0.816422 16 1.11111 16H14.4444C14.7391 16 15.0218 15.8595 15.2301 15.6095C15.4384 15.3595 15.5556 15.0203 15.5556 14.6667V10L20 15.3333V0.666667L15.5556 6ZM5.55556 12V4L10.5556 8L5.55556 12Z",
    fill: "#D1F27A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.13e31393c92836d5ce91cb6073feb947.svg";
export { ForwardRef as ReactComponent };